import './Spinner.css';

export interface SpinnerProps { size?: 'sm' | 'md' | 'lg'; color?: string; className?: string; }

export function Spinner({ size = 'md', color, className = '' }: SpinnerProps) {
  return <div className={`ui-spinner ui-spinner-${size} ${className}`} style={color ? { borderTopColor: color } : undefined} role="status" aria-label="Loading" />;
}
